/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Update SKU when variant changes
  document.addEventListener('DOMContentLoaded', function() {
    // Listen for variant change events
    document.addEventListener('theme:variant:change', function(event) {
      var variant = event.detail.variant;
      var skuWrapper = document.querySelector('[data-sku-wrapper]');
      var skuElement = document.querySelector('[data-variant-sku]');

      if (skuElement && variant) {
        if (variant.sku && variant.sku !== '') {
          skuElement.textContent = variant.sku;
          if (skuWrapper) {
            skuWrapper.style.display = 'block';
          }
        } else {
          if (skuWrapper) {
            skuWrapper.style.display = 'none';
          }
        }
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


/* ====== Konsens GCLID — captura y atribucion ventas showroom (agregado) ====== */

/*!
 * konsens-gclid.js — Captura de GCLID y reenvío a WhatsApp / Tidio / Calendly
 * Joyería Konsens · Atribución de ventas de showroom a Google Ads
 * ---------------------------------------------------------------------------
 * QUÉ HACE
 *   1. Lee gclid / gbraid / wbraid de la URL del anuncio y los guarda 90 días.
 *   2. Inyecta el id del clic en el mensaje pre-escrito de WhatsApp.
 *   3. Lo guarda como propiedad del contacto en Tidio.
 *   4. Lo agrega como utm_content en los enlaces de Calendly.
 *   5. Lo guarda en el perfil de Klaviyo al enviar un formulario (evento klaviyoForms).
 *   Funciona aunque los botones/chat/forms se carguen tarde (MutationObserver + reintentos).
 *
 * INSTALACIÓN (Shopify):
 *   Online Store → Themes → Edit code → layout/theme.liquid
 *   Pegar ANTES de </head>:   <script src="{{ 'konsens-gclid.js' | asset_url }}" defer></script>
 *   (subir este archivo en assets/) — o pegar el contenido dentro de <script>…</script>.
 *   Nota: NO usar como "Custom Pixel" de Shopify: ese sandbox no accede al DOM del tema
 *   ni al localStorage del storefront. Debe ir en el tema.
 *
 * CONFIGURACIÓN: editar solo el bloque KONSENS_GCLID_CONFIG de abajo.
 */
(function () {
  'use strict';

  var KONSENS_GCLID_CONFIG = {
    // Número de WhatsApp de respaldo (solo se usa si un botón no trae el suyo).
    // El sitio usa 56987878210 y 56975707795; cada botón conserva el propio.
    whatsappNumber: '56987878210',
    // Mensaje base; el script le agrega " [ref:ID]" al final.
    whatsappMessage: 'Hola Konsens, quiero consultar por una joya.',
    // Selectores donde puede estar el botón/enlace de WhatsApp.
    whatsappSelectors: [
      '#whatsapp-konsens',
      'a[href*="wa.me"]',
      'a[href*="api.whatsapp.com/send"]',
      'a[href*="web.whatsapp.com/send"]'
    ],
    // Selectores de enlaces/embeds de Calendly.
    calendlySelectors: [
      '#calendly-konsens',
      'a[href*="calendly.com"]',
      '[data-url*="calendly.com"]'
    ],
    // Nombre de la propiedad que se guarda en Tidio.
    tidioPropertyName: 'gclid',
    // Nombre de la propiedad que se guarda en el perfil de Klaviyo.
    klaviyoPropertyName: 'gclid',
    // Días que se conserva el id del clic (= ventana de atribución de Google, máx. 90).
    storageDays: 90,
    // Identificadores de clic a capturar, en orden de prioridad.
    clickIdParams: ['gclid', 'wbraid', 'gbraid'],
    // UTMs que también se conservan y se reenvían a Calendly.
    utmParams: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'],
    // Prefijo de las claves en localStorage.
    storagePrefix: 'konsens_'
  };

  var CFG = KONSENS_GCLID_CONFIG;
  var DAY_MS = 24 * 60 * 60 * 1000;

  /* ----------------------------- utilidades ----------------------------- */

  function getParam(name) {
    try {
      var m = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
      return m && decodeURIComponent(m[1].replace(/\+/g, ' '));
    } catch (e) { return null; }
  }

  function store(key, value) {
    var rec = { value: value, exp: Date.now() + CFG.storageDays * DAY_MS };
    try { localStorage.setItem(CFG.storagePrefix + key, JSON.stringify(rec)); } catch (e) {}
  }

  function read(key) {
    try {
      var rec = JSON.parse(localStorage.getItem(CFG.storagePrefix + key) || '{}');
      return (rec && rec.exp > Date.now() && rec.value) ? rec.value : '';
    } catch (e) { return ''; }
  }

  // Guarda los identificadores de clic y utms presentes en la URL actual.
  function captureFromUrl() {
    CFG.clickIdParams.forEach(function (p) {
      var v = getParam(p);
      if (v) store(p, v);
    });
    CFG.utmParams.forEach(function (p) {
      var v = getParam(p);
      if (v) store(p, v);
    });
  }

  // Devuelve el mejor id de clic disponible (gclid > wbraid > gbraid).
  function getClickId() {
    for (var i = 0; i < CFG.clickIdParams.length; i++) {
      var v = read(CFG.clickIdParams[i]);
      if (v) return v;
    }
    return '';
  }

  function eachMatch(selectors, fn) {
    selectors.forEach(function (sel) {
      var nodes;
      try { nodes = document.querySelectorAll(sel); } catch (e) { return; }
      Array.prototype.forEach.call(nodes, fn);
    });
  }

  // Agrega/actualiza un parámetro en una URL sin duplicarlo.
  function setUrlParam(url, key, value) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set(key, value);
      return u.toString();
    } catch (e) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      var re = new RegExp('([?&])' + key + '=[^&]*');
      if (re.test(url)) return url.replace(re, '$1' + key + '=' + encodeURIComponent(value));
      return url + sep + key + '=' + encodeURIComponent(value);
    }
  }

  /* ------------------------------- WhatsApp ------------------------------ */

  function wireWhatsApp() {
    var id = getClickId();
    var text = CFG.whatsappMessage + (id ? ' [ref:' + id + ']' : '');
    eachMatch(CFG.whatsappSelectors, function (el) {
      var href = el.getAttribute('href') || '';
      var number = CFG.whatsappNumber;
      var nm = href.match(/(?:wa\.me\/|[?&]phone=)(\d{6,15})/);
      if (nm) number = nm[1];
      var newHref = 'https://wa.me/' + number + '?text=' + encodeURIComponent(text);
      if (el.getAttribute('href') !== newHref) el.setAttribute('href', newHref);
    });
  }

  /* ------------------------------- Calendly ------------------------------ */

  function wireCalendly() {
    var id = getClickId();
    if (!id) return;
    eachMatch(CFG.calendlySelectors, function (el) {
      ['href', 'data-url'].forEach(function (attr) {
        var val = el.getAttribute(attr);
        if (!val || val.indexOf('calendly.com') === -1) return;
        var updated = setUrlParam(val, 'utm_content', id);
        CFG.utmParams.forEach(function (p) {
          if (p === 'utm_content') return;
          var v = read(p);
          if (v) updated = setUrlParam(updated, p, v);
        });
        if (updated !== val) el.setAttribute(attr, updated);
      });
    });
  }

  /* ------------------------------- Tidio -------------------------------- */

  var tidioBound = false;

  function setTidioGclid() {
    var id = getClickId();
    if (!id || !window.tidioChatApi) return;
    var props = {};
    props[CFG.tidioPropertyName] = id;
    try {
      if (typeof window.tidioChatApi.setContactProperties === 'function') {
        window.tidioChatApi.setContactProperties(props);
      }
    } catch (e) {}
  }

  // Engancha el gclid a Tidio en los momentos clave — sobre todo cuando el
  // visitante completa el pre-chat (preFormFilled) y pasa a ser contacto.
  function bindTidio() {
    if (tidioBound || !window.tidioChatApi) return;
    tidioBound = true;
    setTidioGclid();
    ['ready', 'conversationStart', 'preFormFilled', 'messageFromVisitor', 'open'].forEach(function (ev) {
      try { window.tidioChatApi.on(ev, setTidioGclid); } catch (e) {}
    });
  }

  /* ------------------------------- Klaviyo ------------------------------- */

  var klaviyoBound = false;

  function klaviyoIdentifyGclid() {
    var id = getClickId();
    if (!id) return;
    var data = {};
    data[CFG.klaviyoPropertyName] = id;
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(data);
      } else if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['identify', data]);
      }
    } catch (e) {}
  }

  // Cuando el visitante ENVÍA un formulario de Klaviyo queda identificado: ese
  // es el momento de adjuntar el gclid a su perfil (evento "klaviyoForms").
  function bindKlaviyo() {
    if (klaviyoBound) return;
    klaviyoBound = true;
    try {
      window.addEventListener('klaviyoForms', function (e) {
        if (e && e.detail && (e.detail.type === 'submit' || e.detail.type === 'stepSubmit')) {
          klaviyoIdentifyGclid();
        }
      });
    } catch (e) {}
    klaviyoIdentifyGclid(); // intento extra para visitantes ya identificados
  }

  /* ------------------------------- init --------------------------------- */

  function wireAll() {
    wireWhatsApp();
    wireCalendly();
  }

  function init() {
    captureFromUrl();
    wireAll();
    bindKlaviyo();

    document.addEventListener('tidioChat-ready', bindTidio);
    if (window.tidioChatApi) bindTidio();
    var tTries = 0;
    var tIv = setInterval(function () {
      if (window.tidioChatApi) { bindTidio(); clearInterval(tIv); }
      else if (++tTries >= 600) clearInterval(tIv);
    }, 2000);

    if (window.MutationObserver) {
      var t;
      var obs = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(wireAll, 250);
      });
      try { obs.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    }

    var tries = 0;
    var iv = setInterval(function () {
      wireAll();
      if (++tries >= 10) clearInterval(iv);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.getKonsensGclid = getClickId;
})();
